import React, { useRef, useState } from 'react';
import { Input, Typography } from '@equinor/opt-ui-core';
import SubmitButton from 'Widgets/SubmitButton/SubmitButton';
import { DialogContent, Spacer } from './styles';
const FeedbackForm = (props) => {
    const { onSubmit, isSubmitting } = props;
    const formRef = useRef(null);
    const [summary, setSummary] = useState('');
    const [description, setDescription] = useState('');
    const submitHandler = () => {
        onSubmit(summary, description);
    };
    const updateSummary = (value) => {
        setSummary(value);
    };
    const updateDescription = (value) => {
        setDescription(value);
    };
    const inputIsInvalid = summary.trimStart().length === 0 || description.trimStart().length === 0;
    return (React.createElement("form", { ref: formRef },
        React.createElement(DialogContent, null,
            React.createElement(Input, { "data-testid": "Summary", label: "Summary", placeholder: "Brief summary of your feedback", value: summary, onChange: updateSummary, fullWidth: true }),
            React.createElement(Input, { "data-testid": "Description", label: "Description", placeholder: "Describe in more detail", multiple: true, inputProps: { rows: 6 }, value: description, onChange: updateDescription, fullWidth: true }),
            React.createElement(Typography, null, "Your email will be included in the feedback, so we can contact you for more information.")),
        React.createElement(Spacer, { style: { display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' } },
            React.createElement(SubmitButton, { formRef: formRef, loading: isSubmitting, disabled: inputIsInvalid || isSubmitting, onSubmit: submitHandler, submitButtonText: "Submit" }))));
};
export default FeedbackForm;
